interface CorrectedAPIVolumeResult {
    NSV: number;
    Corrected_Gravity: number;
}

function correctedAPIVolume(observedGravity: number, observeredTemperature: number, grossBarrels?: number, bsw?: number, topTemperature?: number, bottomTemperature?: number): CorrectedAPIVolumeResult {
    const density = convertGravity(observedGravity);
    var stp_density_guess = density;
    if(observeredTemperature!=60){
        if(observeredTemperature<60){
            stp_density_guess = density+10;
        }else{
            stp_density_guess = density-10;
        }
        var temporary_output = estimateAPI(density, observeredTemperature, 0);
        var count = 0;
        //Iterate using Newton-Raphson method to find the solution of the standard density that would give the observed density at the observed temperature.
        while(Math.abs(temporary_output-density) >0.001){
            const f = estimateAPI(stp_density_guess, observeredTemperature, 0) - density;
            if (Math.abs(f) < 0.001 || count > 100) {
                temporary_output = estimateAPI(stp_density_guess, observeredTemperature, 0);
                break;
            }
            // Numerical derivative
            const h = 1e-6;
            const f_prime =
            (estimateAPI(stp_density_guess + h, observeredTemperature, 0) -
                estimateAPI(stp_density_guess - h, observeredTemperature, 0)) /
            (2 * h);
            if (Math.abs(f_prime) < 1e-12) break; // avoid division by zero
            stp_density_guess = stp_density_guess - f / f_prime;
            count++;
        }
    }
    // else{
    //     //No temperature correction needed, use previously declared observed density as standard density
    // }
    if(!grossBarrels){
        grossBarrels = 0;
    }
    if(!bsw){
        bsw = 0;
    }
    if(!topTemperature || topTemperature===0){
        topTemperature = observeredTemperature;
    }
    if(!bottomTemperature || bottomTemperature===0){
        bottomTemperature = observeredTemperature;
    }
    const tank_density = estimateAPI(stp_density_guess, (topTemperature+bottomTemperature)/2, 0);
    const offloaded_oil_mass = grossBarrels * tank_density * (1-bsw/100);
    const standard_oil_volume = offloaded_oil_mass / stp_density_guess;
    const correctedGravity = convertDensity(stp_density_guess);
    return { NSV: standard_oil_volume, Corrected_Gravity: correctedGravity };
}
function estimateAPI(density:number, alt_temp:number, alt_pres:number, thermal_expansion?:number):number{
    if(!alt_pres){
        alt_pres = 0;
    }
    var alternate_temperature_IPTS68_shifted;
    var base_density_IPTS68_shifted;
    var delta_temp;
    var thermal_expansion_correction;
    var k0;
    var k1;
    var k2;
    var a;
    var b;
    var d60 = 0.01374979547;
    //console.log(density, alt_temp, alt_pres, thermal_expansion);
    if(alt_temp<-58 || alt_temp>302 || alt_pres < 0 || alt_pres >1500 || density < 610.6 || density >1163.5){
        return 0;
    }
    alternate_temperature_IPTS68_shifted = correctedTemp(alt_temp);
    
    //Assume Crude Oil Commodity Group
    k0 = 341.0957;
    k1=0;
    k2 = 0;
    a = (d60/2)*(((k0/density)+k1)*(1/density)+k2);
    b = (2*k0+k1*density)/(k0+((k1+k2*density)*density));
    base_density_IPTS68_shifted = density*(1+((Math.exp(a*(1+0.8*a))-1)/(1+a*(1+1/6*a)*b)));
    thermal_expansion_correction = ((k0/base_density_IPTS68_shifted)+k1)*(1/base_density_IPTS68_shifted)+k2;
    delta_temp = alternate_temperature_IPTS68_shifted - 60.0068749;
    var ctl;
    var fs;
    var cpl;
    ctl = Math.exp(-thermal_expansion_correction*delta_temp*(1+0.8*thermal_expansion_correction*(delta_temp+d60)));
    fs = Math.exp(-1.9947+0.00013427*alternate_temperature_IPTS68_shifted+(793920+2326.0*alternate_temperature_IPTS68_shifted)/(base_density_IPTS68_shifted*base_density_IPTS68_shifted));
    cpl = 1/(1-(Math.pow(10, -5))*fs*alt_pres);
    var cptl = ctl*cpl;
    // console.log("Thermal Expansion Correction: "+thermal_expansion_correction);
    // console.log("CTL: "+ctl);
    // console.log("CPL: "+cpl);
    // console.log("CPTL: "+cptl);
    return density*cptl;
    
}
function convertGravity(gravity:number):number{ 
    return (141.5/(gravity + 131.5)*999.016 );
}
function convertDensity(density:number):number{
    return (141.5/(density/999.016)-131.5 );
}
function correctedTemp(temperature:number):number{
    var celcius = (temperature - 32)/1.8;
    var tau = celcius/630;
    var delta = (
        -0.148759 +
            (-0.267408 +
                (1.080760+
                    (1.269056+
                        (-4.089591+
                            (-1.871251+
                                (7.438081 +
                                    -3.536296 * tau
                                )*tau
                            )*tau
                        )*tau
                    )*tau
                )*tau

            )*tau
    )*tau;
    celcius = celcius - delta;
    return (1.8*celcius + 32);
}

const gravityCorrection = (temp: number, obsGrav: number): number => {
    // const grav = (141.5 / (obsGrav + 131.5)) * 999.016;
    // const thermExp = 341.0957 / (grav ** 2);
    // const CTL = Math.E ** (
    //     (-thermExp * (temp - 60.0068749)) * (1 + (0.8 * thermExp) * (temp - 60.0068749))
    // );
    // return (141.5 * 999.016) / (grav / CTL) - 131.5;
    return correctedAPIVolume(obsGrav, temp).Corrected_Gravity;
};

const netBarrelsCalculation = (temp: number, obsGrav: number, gross: number, bsw: number, carrier?:number, topTemperature?: number,bottomTemperature?: number): number => {
    var netbarrels = 0;
    
    if(!topTemperature || !bottomTemperature || (topTemperature === 0 && bottomTemperature === 0)){
        //top and bottom temperature are required for the API volume correction, if not provided we will assume they are equal to the observed temperature, which means no temperature gradient in the tank and therefore no temperature correction needed for the volume calculation.
        
        netbarrels= correctedAPIVolume(obsGrav, temp, gross, bsw).NSV;
        // const grav = (141.5 / (corrGrav + 131.5)) * 999.016
        // const thermExp2 = (341.0957 / (grav ** 2))
        // const CTL2 = Math.E ** ((-thermExp2 * (temp - 60.0068749)) * (1 + (0.8 * thermExp2) * (temp - 60.0068749)))
        // return gross * CTL2 * (1 - bsw / 100)
    }else{
        if(carrier){
            switch(carrier){
                case 44:
                case 19:
                case 75:
                case 37: 
                case 32:
                case 36:
                    //for future use, trailer gauge API Correction method

                case 25:
                case 29:
                case 20:
                case 33:
                    //for future use, tank level API Correction method
                default:
                  netbarrels = correctedAPIVolume(obsGrav, temp, gross, bsw,topTemperature,bottomTemperature).NSV;
            }
        }else{
            netbarrels= correctedAPIVolume(obsGrav, temp, gross, bsw,topTemperature,bottomTemperature).NSV;
        }
        
    }
       
    return netbarrels;
};

export const calculateNetBarrels = ({
    observed_temperature,
    observed_gravity,
    gross_barrels,
    bsw,
    reported_net,
    top_temperature,
    bottom_temperature
}: {
    observed_temperature: number,
    observed_gravity: number,
    gross_barrels: number,
    bsw: number,
    reported_net?: number,
    top_temperature?: number | string | undefined,
    bottom_temperature?: number | string | undefined,
}) => {

    const temp = Number(observed_temperature);
    const obsGrav = Number(observed_gravity);
    const gross = Number(gross_barrels);
    const bswNum = Number(bsw);
    
    // Convert temperatures to numbers, handling empty strings and undefined
    const topTempRaw = (top_temperature === "" || top_temperature === undefined) ? undefined : Number(top_temperature);
    const bottomTempRaw = (bottom_temperature === "" || bottom_temperature === undefined) ? undefined : Number(bottom_temperature);
    
    // If both temperatures are 0, treat them as undefined
    const topTemp = (topTempRaw === 0 && bottomTempRaw === 0) ? undefined : topTempRaw;
    const bottomTemp = (topTempRaw === 0 && bottomTempRaw === 0) ? undefined : bottomTempRaw;
    
    const reportedNet = reported_net !== undefined && reported_net !== null ? Number(reported_net) : undefined;

    if (isNaN(temp) || isNaN(obsGrav) || isNaN(gross) || isNaN(bswNum)) {
        return [false, 0];
    }

    const calculated_net = netBarrelsCalculation(temp, obsGrav, gross, bswNum, undefined, topTemp, bottomTemp);
    if (reportedNet && reportedNet > 0) {
        return [calculated_net, Math.abs(reportedNet - calculated_net) > 1];
    } else {
        return [calculated_net];
    }
};

export const calculateCorrectedGravity = ({
    observed_temperature,
    observed_gravity,
    reported_grav,
}: {
    observed_temperature: number,
    observed_gravity: number,
    reported_grav?: number,
}) => {

    const temp = Number(observed_temperature);
    const obsGrav = Number(observed_gravity);
    const reportedGrav = reported_grav !== undefined && reported_grav !== null ? Number(reported_grav) : undefined;

    if (isNaN(temp) || isNaN(obsGrav)) {
        return [false, 0];
    }

    const calculated_grav = gravityCorrection(temp, obsGrav);
    if (reportedGrav && reportedGrav > 0) {
        return [calculated_grav, Math.abs(reportedGrav - calculated_grav) > 1];
    } else {
        return [calculated_grav];
    }
};